export default __webpack_public_path__ + "static/media/shell.7ba425d1.png";